import Vue from 'vue'
import Vuex from 'vuex'
import contextmenu from './contextmenu'
import copy from './copy'
import layer from './layer'
import snapshot from './snapshot'

Vue.use(Vuex)

const data = {
    state: {
        ...contextmenu.state,
        ...copy.state,
        ...layer.state,
        ...snapshot.state,

        editMode: 'edit', // 编辑器模式 edit preview
        canvasStyleData: { // 页面全局数据
            width: 375,
            height: 667,
            scale: 100,
        },
        activeName: 'attr',
        ModelTitleStyle: { ModelTitle_CN: '首页', color: '#000000', position: 'left', background: 'url(undefied)', pageBackground: '#fff', themeColor: '#0062FF' },
        pages_json: { color: '#333', selectColor: '#409EFF', backgroundColor: '#fff', navigationList: [{ id: 0, inactiveImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', activeImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', title: '首页', eventParam: { path: '', title: '', appid: '' } }, { id: 1, inactiveImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', activeImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', title: '首页', eventParam: { path: '', title: '', appid: '' } }, { id: 2, inactiveImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', activeImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', title: '首页', eventParam: { path: '', title: '', appid: '' } }, { id: 3, inactiveImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', activeImgUrl: 'https://qz.faisys.com/image/wxImage/wxMaterial/1-1.jpg?v=201808081724', title: '首页', eventParam: { path: '', title: '', appid: '' } }] },
        layoutList: { ColumnNum: 0, FirstColumnContent: '', FirstColumnHeight: 0, FirstColumnWigth: 0, PreTBID: 0, SiteID: 0, TBID: 0, TBOrder: 0, TempID: 0 },
        TempID: null,
        componentData: [], // 画布组件数据
        selectedIndex: 0,
        draggableStatus: false,
        curComponent: null,
        curComponentIndex: null,
        // 点击画布时是否点中组件，主要用于取消选中组件用。
        // 如果没点中组件，并且在画布空白处弹起鼠标，则取消当前组件的选中状态
        isClickComponent: false,
        updateComponent: false,//表单是否更新
        routeChange: false,//路由变化
        clickIndex: null,
        TempType: 1,//判断是否是报名页
    },
    mutations: {
        ...contextmenu.mutations,
        ...copy.mutations,
        ...layer.mutations,
        ...snapshot.mutations,
        setTempType(state, type) {
            state.TempType = type
        },
        setClickComponentStatus(state, status) {
            state.isClickComponent = status
        },
        setActiveName(state, name) {
            state.activeName = name
        },
        setEditMode(state, mode) {
            state.editMode = mode
        },
        setUpdateComponent(state, status) {
            state.updateComponent = status
        },
        setClickIndex(state, index) {
            state.clickIndex = index
        },
        setRouteChange(state, status) {
            state.routeChange = status
        },
        setCanvasStyle(state, style) {
            state.canvasStyleData = style
        },
        setTempID(state, id) {
            state.TempID = id
        },
        setPagesJson(state, info) {
            state.pages_json = info
        },
        setModelTitleStyle(state, titleStyle) {
            state.ModelTitleStyle = titleStyle
        },
        setCurComponent(state, { component, index }) {
            state.curComponent = component
            state.curComponentIndex = index
        },
        setShapeStyle({ curComponent, top, left, width, height }) {
            if (top || top == 0) curComponent.CssSet.top = top;
            if (left || left == 0) curComponent.CssSet.left = left;
            if (width || width == 0) curComponent.CssSet.width = width;
            if (height || width == 0) curComponent.CssSet.height = height;
        },

        setShapeSingleStyle({ curComponent }, { key, value }) {
            curComponent.style[key] = value
        },

        setComponentData(state, componentData = []) {
            Vue.set(state, 'componentData', componentData)
        },
        setSelectedIndex(state, value = 1) {
            Vue.set(state, 'selectedIndex', value)
        },
        setLayoutList(state, list) {
            state.layoutList = list
        },
        addComponent(state, { component, index, delectIndex }) {
            state.updateComponent = true
            let ComponentList = []
            if (state.componentData.length > 0) { state.componentData.forEach(e => { ComponentList.push(e.Component) }) }

            if (component.Component == 'rwSubmitButton' && ComponentList.indexOf('rwSubmitButton') !== -1) { return false }
            if (delectIndex !== undefined) {
                state.componentData.splice(delectIndex, 1, component)
                return false
            }
            if (index !== undefined) {
                state.componentData.splice(index, 0, component)
            } else {
                console.log(state.componentData)
                state.componentData.push(component)
            }
        },
        addPageComponent(state, { component }) {
            if (component.pid !== undefined) {
                component.CssSet.top += 10
                component.CssSet.left += 10
                state.componentData[component.pid].blockList[0].children.push(component)
            } else if (component.PreBlockID !== undefined && component.PreBlockID !== 0) {
                component.CssSet.top += 10
                component.CssSet.left += 10
                state.componentData.forEach((e, index) => {
                    if (e.blockList[0].BlockID == component.PreBlockID) {
                        state.componentData[index].blockList[0].children.push(component)
                    }
                })
            } else {
                let layoutList = { ColumnNum: 0, FirstColumnContent: '', FirstColumnHeight: 0, FirstColumnWigth: 0, PreTBID: 0, SiteID: 0, TBID: 0, TBOrder: 0, TempID: 0, blockList: [] }
                layoutList.blockList.push(component)
                layoutList.TBOrder = state.componentData.length
                layoutList.FormOrder = state.componentData.length
                state.componentData.push(layoutList)
            }
        },
        deleteComponent(state, index) {
            state.updateComponent = true
            // state.curComponent = null
            if (state.clickIndex !== null) {
                state.componentData.splice(state.clickIndex, 1)
            } else {
                index = state.curComponentIndex
                state.componentData.splice(index, 1)
            }
            for (let i = 0; i < state.componentData.length; i++) {
                state.componentData[i].FormOrder = i;
            }
        },
        delectDropNodeElement(state, obj) {
            state.componentData[obj.pid].blockList[0].children.splice(obj.id, 1)
        },
        addDropNodeElement(state, obj) {
            const index = parseInt(obj.index)
            obj.nodeData.id = state.componentData[index].blockList[0].children.length
            obj.nodeData.pid = index
            state.componentData[index].blockList[0].children.push(obj.nodeData)
        },
        changChildNodeStyle(state, obj) {
            state.componentData[obj.PreIndex].children[obj.index].CssSet = obj.CssSet
        }
    },
}

export default new Vuex.Store(data)


// WEBPACK FOOTER //
// ./src/store/index.js